import { Box, Container, Grid } from '@mui/material'
import React from 'react'
import home from '../../assets/video/home.mp4'
import homepng from '../../assets/img/home.png'
import twitter from "../../assets/img/twitter.png"
import telegram from "../../assets/img/telegram.png"
import { ButtonEx, GridEx, PageWrapper, SocialImg, SocialMeidaBox, TypographyEx } from '../../styles'
import { telegramLink, twitterLink } from '../config'

const Home = () => {
  return (
    <PageWrapper bg="#FFCE00">
        <Container maxWidth="xl">
            <Grid container>
                <GridEx xs={12} md={5} lg={4} item>
                    <video style={{width: '100%', maxWidth: 400}} loop autoPlay muted>
                        <source src={home} type="video/mp4" />
                        Your browser does not support HTML video.
                    </video>
                    <img src={homepng} alt="home-main-image" className='mainImg' />
                </GridEx>
                <GridEx xs={12} md={7} lg={8} item center>
                    <TypographyEx variant="inherit" align="right">
                        Wojak has a best fren name $PEPE and they lived in the ghetto slums of degen city throughout their entire lives. They both worked at McDonalds for decades together until one day his fren $PEPE launched a token that made him millions of dollars. Wojak felt so left behind that he fomo'd in and revenge traded and now he is double rekt and has to keep working at mcdonalds. He’s asking his fellow frens/degens who missed out on $PEPE and have been rugged or taxfarmed by devs to join him by investing in his degen project. <br />
                        Don't have the money to ape in? Click on "Earn" in the Menu on the top right to find out amazing opportunities to make buck!
                    </TypographyEx>
                    <SocialMeidaBox>
                        <a href={twitterLink} target='_blank'>
                            <SocialImg src={twitter} alt="twitter-logo" />
                        </a>
                        <a href={telegramLink} target='_blank'>
                            <SocialImg src={telegram} alt="telegram-logo" />
                        </a>
                    </SocialMeidaBox>
                    <Box sx={{textAlign: "right", mt:6 }}>
                        <ButtonEx bg="#C20D00">BUY NOW</ButtonEx>
                        <ButtonEx bg="#000000">CHART</ButtonEx>
                    </Box>
                    <img src={homepng} alt="home-main-image" className='primaryImg' />
                </GridEx>
            </Grid>
        </Container>
    </PageWrapper>
  )
}

export default Home